const $ = jQuery;

$(document).ready(function () {
    imagesLoaded($('ul.products'), function() {
        $.fn.yith_wcqv_init();
    });

    $('body').on('click', 'button.quantity-change', function () {
        const input = $(this).parent('.quantity').find('input.qty');
        const value = parseInt(input.val());
        if ($(this).hasClass('quantity-plus')) {
            input.val(value + 1);
        }
        if ($(this).hasClass('quantity-minus')) {
            if (value > 1) {
                input.val(value - 1);
            }
        }
        input.change();
    });

    $('.section-reviews .toggle-reviews').click(function(e) {
        e.preventDefault();
        if ($(this).hasClass('closed')) {
            $('.section-reviews .reviews-container').slideDown();
            $(this).removeClass('closed');
            $(this).html('Close reviews');
        } else {
            $('.section-reviews .reviews-container').slideUp();
            $(this).addClass('closed');
            $(this).html('Show reviews');
        }
    });

    $('.section-shop #sidebar .sidebar-control a').click(function(e) {
        e.preventDefault();
        var sidebar = $('.section-shop #sidebar .sidebar-widgets');
        if (sidebar.hasClass('open')) {
            sidebar.slideUp();
            sidebar.removeClass('open');
        } else {
            sidebar.slideDown();
            sidebar.addClass('open');
        }
    });
});



// WEBPACK FOOTER //
// ./src/js/shop.js